module.exports = __webpack_public_path__ + "img/united-kingdom.6f382b2d.png";